<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <!-- <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-main style="padding:0">
          <v-text-field label="Titel der Umfrage" style="margin:10px;" v-model="inputText"></v-text-field>
      </v-main>

    </v-card> -->
    <v-card class="dialog">
      <div class="header">
        <v-text-field label="Titel der Umfrage" v-model="inputText"></v-text-field>
      </div>
      <v-card-actions>
        <v-btn id="leftButton" text @click.stop="cancel">Abbrechen</v-btn>        
        <v-btn id="rightButton" text @click.stop="agree" color="primary">Umfrage kopieren</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  components:{
    VueEditor 
  },
  name: "FormDlg",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      inputText: "",
      title: null,
      description: "",
      customTitlePage: false,
      options: {
        width: 800,
        zIndex: 200,
      }
    };
  },

  methods: {
    open(title, inputText, options) {
      this.dialog = true;
      this.title = title;
      this.inputText = inputText;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(this.inputText);
      this.dialog = false;
    },
    cancel() {
      this.reject(false);
      this.dialog = false;
    }
  }
};
</script>